import React from 'react';
import { UI_TEXT, AGE_CATEGORIES } from '../utils/constants';

const FilterBar = ({
  selectedGenre,
  setSelectedGenre,
  selectedAge,
  setSelectedAge,
  genres,
  showOnlyNew,
  setShowOnlyNew,
  hasNewBooks,
}) => {
  return (
    <div className={`grid grid-cols-1 gap-4 ${hasNewBooks ? 'md:grid-cols-3' : 'md:grid-cols-2'}`}>
      {/* Genre Filter */}
      <div>
        <label htmlFor="genre-filter" className="block text-sm font-medium text-gray-700 mb-2">
          {UI_TEXT.filterGenre}
        </label>
        <select
          id="genre-filter"
          className="
            block w-full px-4 py-3
            bg-surface-high border-0 rounded-xl
            text-on-surface text-base
            focus:outline-none focus:ring-2 focus:ring-primary/40
            transition-all duration-150
          "
          aria-label={UI_TEXT.filterGenre}
          value={selectedGenre}
          onChange={(e) => setSelectedGenre(e.target.value)}
        >
          <option value="Усі">{UI_TEXT.allGenres}</option>
          {genres.map(genre => (
            <option key={genre} value={genre}>{genre}</option>
          ))}
        </select>
      </div>

      {/* Age Category Filter */}
      <div>
        <label htmlFor="age-filter" className="block text-sm font-medium text-gray-700 mb-2">
          {UI_TEXT.filterAge}
        </label>
        <select
          id="age-filter"
          className="
            block w-full px-4 py-3
            bg-surface-high border-0 rounded-xl
            text-on-surface text-base
            focus:outline-none focus:ring-2 focus:ring-primary/40
            transition-all duration-150
          "
          aria-label={UI_TEXT.filterAge}
          value={selectedAge}
          onChange={(e) => setSelectedAge(e.target.value)}
        >
          {AGE_CATEGORIES.map(age => (
            <option key={age} value={age}>
              {age === 'Усі' ? UI_TEXT.allAges : age}
            </option>
          ))}
        </select>
      </div>
      {/* New Arrivals Filter — only shown when at least one book is marked новинка */}
      {hasNewBooks && (
        <div className="flex items-end pb-0.5">
          <label className="flex items-center gap-3 px-4 py-3 w-full rounded-xl bg-surface-high cursor-pointer select-none">
            <input
              type="checkbox"
              id="new-filter"
              className="w-4 h-4 rounded accent-primary cursor-pointer"
              checked={showOnlyNew}
              onChange={(e) => setShowOnlyNew(e.target.checked)}
              aria-label={UI_TEXT.filterNew}
            />
            <span className="text-on-surface text-base">{UI_TEXT.filterNew}</span>
          </label>
        </div>
      )}
    </div>
  );
};

export default FilterBar;